import ApplicationAdapter from './application';

class FreelancerMetricAdapter extends ApplicationAdapter {
  pathForType() {
    return 'analytics/freelancer';
  }
}

export default FreelancerMetricAdapter;
